/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class PreviewRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;

    return hash({
      optionSet: store.findRecord('school-options/set', params.set_id),
      options: store.query('school-options/field', {
        optionSetIds: JSON.stringify([params.set_id]),
      }),
    });
  }
}
